/* global $ */
const windowWidth = $(window).width()
const largeSize = 1280

// Scroll to program search
$('#scroll-program-search').click(function (e) {
  e.preventDefault()
  const whereTo = $('#program-search').offset().top
  $('html, body').animate({
    scrollTop: whereTo
  }, 400)
})

// Programs Filtering
$('#full-search-form input[type=checkbox]').change(function () {
  if ($(this).is(':checked')) {
    $(this).parent().addClass('selected')
  } else {
    $(this).parent().removeClass('selected')
  }
})

$('#program-search input[type=submit]').click(function (e) {
  e.preventDefault()
  showProgramsBasedOnFiltering()
})

function showProgramsBasedOnFiltering () {
  const programsHolder = $('#program-types')

  programsHolder.find('.program').removeClass('expandable-list__subitem--filtered-out')
  programsHolder.find('.course').removeClass('expandable-list__subitem--filtered-out')

  $('#full-search-form input[type=checkbox].int-check:checked').each(function () {
    programsHolder.find('.program').not('.int-' + $(this).val()).addClass('expandable-list__subitem--filtered-out')
    programsHolder.find('.course').not('.int-' + $(this).val()).addClass('expandable-list__subitem--filtered-out')
  })

  $('#full-search-form input[type=checkbox].part-check:checked').each(function () {
    programsHolder.find('.program').not('.part-' + $(this).val()).addClass('expandable-list__subitem--filtered-out')
    programsHolder.find('.course').not('.part-' + $(this).val()).addClass('expandable-list__subitem--filtered-out')
  })

  const selectedCampus = $('#full-search-form #location').val()
  if (selectedCampus !== '' && selectedCampus !== '0') {
    programsHolder.find('.program').not('.campus-' + selectedCampus).addClass('expandable-list__subitem--filtered-out')
    programsHolder.find('.course').not('.campus-' + selectedCampus).addClass('expandable-list__subitem--filtered-out')
  }

  const selectedPeriod = $('#full-search-form #period').val()
  if (selectedPeriod !== '' && selectedPeriod !== '0') {
    programsHolder.find('.program').not('.period-' + selectedPeriod).addClass('expandable-list__subitem--filtered-out')
    programsHolder.find('.course').not('.period-' + selectedPeriod).addClass('expandable-list__subitem--filtered-out')
  }

  $(programsHolder.find('.program-type')).each(function () {
    const nbChildrenPrograms = $(this).find('.program:not(\'.expandable-list__subitem--filtered-out\')').length
    const nbChildrenCourses = $(this).find('.course:not(\'.expandable-list__subitem--filtered-out\')').length

    $(this).find('.js-program-total-nb').html(nbChildrenPrograms + nbChildrenCourses)
  })

  $(programsHolder.find('.program-type-category')).each(function () {
    const nbChildrenPrograms = $(this).find('.program:not(\'.expandable-list__subitem--filtered-out\')').length
    const nbChildrenCourses = $(this).find('.course:not(\'.expandable-list__subitem--filtered-out\')').length

    $(this).find('.js-program-total-nb').html(nbChildrenPrograms + nbChildrenCourses)
  })

  $(programsHolder.find('.metadomain-title')).each(function () {
    const nbChildrenPrograms = $(this).next('.expandable-list').find('.program:not(\'.expandable-list__subitem--filtered-out\')').length
    const nbChildrenCourses = $(this).next('.expandable-list').find('.course:not(\'.expandable-list__subitem--filtered-out\')').length

    $(this).find('.js-program-total-nb').html(nbChildrenPrograms + nbChildrenCourses)
  })

  if (windowWidth < largeSize) {
    const scrollTo = $('#main-content').position().top
    $('html, body').animate({
      scrollTop: scrollTo
    })
  }
}

// Shows and hides the course info from a course
$('.open-course-infos').click(function () {
  $(this).parents('.session-course').find('.course-infos').slideToggle()
  $(this).parents('.session-course').toggleClass('course-open')
  $('.course-infos').each(function () {
    $(this).css('padding-left', $(this).parent().find('.course-identification').position().left - 30)
  })
  return false
})

// Course ponderation legend

// Single Trigger for Programs Page
$('.course-ponderation-trigger-single').hover(function () {
  const courseLeft = $(this).position().left + $(this).width() - 20
  const courseTop = $(this).position().top - 20

  $('#ponderation-holder').css('top', courseTop)
  $('#ponderation-holder').css('left', courseLeft)
  $('#ponderation-holder').show()
}, function () {
  $('#ponderation-holder').hide()
})

// Related Triger for Courses in macro
$('.course-ponderation-trigger').hover(function () {
  const elem = $(this).parents('.session-courses').find('.ponderation-holder')
  const courseLeft = $(this).position().left + $(this).width() - 20
  const courseTop = $(this).position().top - 20

  elem.css('top', courseTop)
  elem.css('left', courseLeft)
  elem.show()
}, function () {
  const elem = $(this).parents('.session-courses').find('.ponderation-holder')
  elem.hide()
})
